._tourTooltipWrapper_18arw_1 {
  z-index: 100000000; }
